import request from "@/method/request";
import { Row, Select, Spin } from 'antd';
import moment from 'moment';
import React, { Component } from 'react';
import { chineseNewYear } from "@/method/data";
import { setKarte } from './compute'
import "./index.scss";

const { Option } = Select

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY'),
            data: [],
            lastdata: [],
            loading: true,
            loadingSave: false,
            print: false,
            dateData: [],
            area: "东南华南",
        }
    }


    componentDidMount() {
        let date = Number(this.state.date || "0");
        let dateData = [];
        let len = date - 2018 + 3;
        for (let i = 0; i < len; i++) {
            dateData.push((2018 + i).toString())
        }
        this.setState({ dateData });
        this.getData({ date: this.state.date, area: this.state.area, });
    }

    getData = async ({ date, area }) => {
        try {
            let month = chineseNewYear[moment().format('Y')].m;
            let lastmonth = chineseNewYear[moment().subtract(1, 'year').format('Y')].m;
            const year = moment(date).format('YYYY');
            const res = await request(
                `/_4_2_daily/area_holidays?year=${year}&month=${month}&area=${area}&lastmonth=${lastmonth}`);

            let data = res.data || [];
            data.forEach((item, i) => {
                // 春节
                const index = chineseNewYear[moment(date).format('Y')].d - 1;
                const lastIndex = chineseNewYear[moment(date).subtract(1, 'years').format('Y')].d - 1;
                data[i].data = item.data.slice(index, index + 7);
                data[i].lastdata = item.lastdata.slice(lastIndex, lastIndex + 7);
            });
            console.log(data);
            // adr occ
            setKarte({
                id: "chartOcc",
                title: `${date - 1}年 ADR+OCC`,
                dataName: data.map(x => x.name),
                dataY: data.reduce((a, b, i) => {
                    a.push({ name: b.name, type: "percent", data: b.lastdata.map(_x => (_x.occ * 100).toFixed(1)) });
                    a.push({ name: b.name, data: b.lastdata.map(_x => Number(_x.adr).toFixed(0)) });
                    return a
                }, [])
            });
            setKarte({
                id: "chartAdr",
                title: `${date}年 ADR+OCC`,
                dataName: data.map(x => x.name),
                dataY: data.reduce((a, b, i) => {
                    a.push({ name: b.name, type: "percent", data: b.data.map(_x => (_x.occ * 100).toFixed(1)) });
                    a.push({ name: b.name, data: b.data.map(_x => Number(_x.adr).toFixed(0)) });
                    return a
                }, [])
            });

            // revpar
            setKarte({
                id: "revpar_year",
                title: `${date - 1}年 RevPAR`,
                dataName: data.map(x => x.name),
                dataY: data.map(x => ({ name: x.name, data: x.lastdata.map(y => Number(y.revpar).toFixed(0)) }))
            });
            setKarte({
                id: "revpar_last",
                title: `${date}年 RevPAR`,
                dataName: data.map(x => x.name),
                dataY: data.map(x => ({ name: x.name, data: x.data.map(y => Number(y.revpar).toFixed(0)) }))
            });

            // room rev
            setKarte({
                id: "roomrev_year",
                title: `${date - 1}年 Room Revenue`,
                dataName: data.map(x => x.name),
                dataY: data.map(x => ({ name: x.name, data: x.lastdata.map(y => Number(y.rev).toFixed(0)) }))
            });
            setKarte({
                id: "roomrev_last",
                title: `${date}年 Room Revenue`,
                dataName: data.map(x => x.name),
                dataY: data.map(x => ({ name: x.name, data: x.data.map(y => Number(y.rev).toFixed(0)) }))
            });
            this.setState({ data, loading: false });
        } catch (error) {
            console.log(error);
            this.setState({ loading: false });
        }
    }



    render() {
        const { dateData, loading, data, date, area } = this.state;

        return (
            <Spin spinning={loading}>
                <div className="table7_1_1 table7_6 table4_2_area_summary" id="table4_2_2" style={{ height: 'auto' }}>
                    <Row className="title">
                        <Row>春节区域报表</Row>
                        <div className="title-select">
                            <Select
                                placeholder="请选择年份"
                                style={{ width: 120 }}
                                value={date}
                                onChange={(str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true,
                                    }, () => {
                                        this.getData({ date: str, area })
                                    });
                                }}
                            >
                                {dateData.map((x, i) => {
                                    return (
                                        <Option value={x} key={x}>{x}年</Option>
                                    )
                                })}
                            </Select>
                            <Select
                                allowClear
                                defaultValue={area}
                                style={{ width: 200, marginLeft: 20 }}
                                onChange={(value) => {
                                    this.setState({
                                        data: [],
                                        loading: true,
                                        area: value
                                    }, () => {
                                        this.getData({ date, area: value })
                                    });
                                }}
                            >
                                <Option value="东南华南">东南华南</Option>
                                <Option value="华北华中">华北华中</Option>
                                <Option value="江浙沪皖">江浙沪皖</Option>
                                <Option value="西南">西南</Option>
                            </Select>
                        </div>
                    </Row>
                    <Row className="title">
                        <div className="chart-4-2">
                            <div id="chartOcc"></div>
                            <div id="chartAdr"></div>
                            <div id="revpar_year"></div>
                            <div id="revpar_last"></div>
                            <div id="roomrev_year"></div>
                            <div id="roomrev_last"></div>
                        </div>
                    </Row>
                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-2-daily/regionalReport/chineseNewYear/index.js